/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable, InjectionToken } from '@angular/core';

@Injectable()
export class AccessibilityConfig {
    enable?: boolean;
}

export const ACCESSIBILITY_CONFIG = new InjectionToken<AccessibilityConfig>('ACCESSIBILITY_CONFIG');
